import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=45043dc0&scoped=true&"
import script from "./UsersTable.vue?vue&type=script&lang=js&"
export * from "./UsersTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=45043dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45043dc0",
  null
  
)

export default component.exports